import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";

export function Unit({ value }) {
  return (
    <div>
      {Number(value).toLocaleString()}
      &nbsp; <MDTypography variant="overline">und</MDTypography>
    </div>
  );
}

Unit.propTypes = {
  value: PropTypes.any.isRequired,
};
